import FindIcon from '../findProductsIcon.js';
export default{
    animals : [
        {
            id: 1,
            description : 'Imena za krave',
            description_path : 'Imena za krave',
            block: 'Imena krava',
            title: `
            Po narodnim verovanjima, ali i istraživanjima, ukoliko krava ima ime i pristupi joj se lično, pozove po imenu, davaće više mleka, a telenje će biti samostalno i brzo, a telad će biti zdrava i kvalitetna.</br></br>
            Imena krava daju se od milja, po ličnim ženskim imenima, po poznatim javnim ličnostima (glumci, pevači, sportisti, političari), ali i drugi načini imenovanja (likovi iz serija i filmova, likovi iz knjiga).</br></br>
            Predstavljamo nekoliko desetina imena za krave koja su najčešća u našem jeziku i podneblju:
            `,
            img : FindIcon.find('Krave za klanje').img2,
            color : FindIcon.find('Krave za klanje').color,
            size : FindIcon.find('Krave za klanje').size,
            names: `
            </br> Ana</br></br>

Belka, Belkica, Berta, Bojana, Bona, Brena</br></br>

Ceca, Cica, Crna, Cveta, Cvetanka, Cvetka, Cvetulja</br></br>

Dara, Dora, Drina</br></br>

Frida</br></br>

Gala, Gara, Garova</br></br>

Helga</br></br>

Indira</br></br>

Jela</br></br>

Kitova, Kuma</br></br>

Lidija, Liza, Lozava</br></br>

Ljuba, Ljubova</br></br>

Maca, Mačkica, Maja, Maza, Mica, Mila, Milka, Milkica, Mira, Mrka, Mrkova</br></br>

Naca, Nata</br></br>

Petra, Petruša</br></br>

Ranka, Roza, Rozica, Rujka, Rumenka, Ruža, Ruška</br></br>

Sandra, Saška, Srna, Sofka, Sofija, Sonja, Siva</br></br>

Šarka, Šarulja</br></br>

Veca, Vera</br></br>

Zvezda, Zvezdana</br></br>

Željka</br></br>`
        },
        {
            id: 2,
            title :`Imena ovaca nekada su se davala na osnovu izgleda ovce ili od milja, a danas dobijaju i neka savremena imena na osnovu poznatih ličnosti.</br></br>
            
            Predstavljamo nekoliko imena za ovce koja su najčešća u našem jeziku i podneblju:`,
            description : 'Imena za ovce',      
            description_path : 'Imena za ovce',
            block: 'Imena ovaca',
            img : FindIcon.find('Ovca').img2,
            color : FindIcon.find('Ovca').color,
            size : FindIcon.find('Ovca').size,
            names : `
            Belka, Belica, Biba, Bika, Blizna, Breza, Brna, Buba</br></br>

Ciga, Cigica, Cvitka, Cvetka, Crna</br></br>

Čađa, Čula</br></br>

Dika, Dunja</br></br>

Gala, Gara, Gizda</br></br>

Jaga, Jagoda, Jadranka, Jasna, Jela</br></br>

Kulja</br></br>

Liska, Lija</br></br>

Maca, Malenka, Mara, Mica, Milka, Mrka, Mrkuša, Mrva</br></br>

Parica, Pirga, Plemenka, Putka</br></br>

Rema, Rogulja, Ruža</br></br>

Srna, Srnela</br></br>

Šara, Šarga, Šarka</br></br>

Zeka, Zekica, Zrna</br></br>

Žuna</br></br>
            `
        },
        {
            id: 3,
            title: `Još u prošlim vekovima kada su se volovi i bikovi koristili za rad i borbe u koridama, svaki od njih je imao svoje lično ime. Danas se jako retko volovi koriste za rad, a sve je manji broj bikova za borbe u koridama. I dalje je ipak ostala tradicija da bik ima ime.</br></br>
            Predstavljamo nekoliko desetina imena za bikove i volove koja su najčešća u našem jeziku i podneblju:`,
            block: 'Imena bikova i volova',
            description_path : 'Imena za bikove i volove',
            description : 'Imena za bikove i volove',
            img : FindIcon.find('Bikovi').img2,
            color : FindIcon.find('Bikovi').color,
            size : FindIcon.find('Bikovi').size,
            names: `
            Barun, Beli, Branko, Brizonja, Brižan</br></br>

Crni, Cvitonja</br></br>

Dikonja, Dobrivoje</br></br>

Ferdinand, Fića</br></br>

Garonja</br></br>

Jablan, Javor, Jelonja</br></br>

Kitonja</br></br>

Lozonja</br></br>

Ljuba, Ljuban</br></br>

Maks, Mića, Mile, Mili, Miško</br></br>

Peca, Peronja, Petrašin</br></br>

Reponja, Rista, Rogonja, Roki, Rudonja</br></br>

Saša</br></br>

Šaran, Šaronja, Šironja, Sivonja</br></br>

Žuća</br></br>
            `
        },
        {
            id: 4,
            title: `Imena konja se daju na osnovu ličnih imena, na osnovu izgleda, na osnovu podneblja, od milja, internacionalna imena, savremena imena po imenima poznatih javnih ličnosti i drugi načini.</br></br>
            Predstavljamo nekoliko desetina imena za konje koja su najčešća u našem jeziku i podneblju:`,
            description_path : 'Imena za konje',
            description : 'Imena za konje',
            block: 'Imena konja',
            img : FindIcon.find('Konj').img2,
            color : FindIcon.find('Konj').color,
            size : FindIcon.find('Konj').size,
            names : `
            Aga, Arap, Atila</br></br>

Bećar, Bilac, Brnac, Brnja, Bugar</br></br>

Car, Cezar, Ciga, Crni, Cvetko, Cvitko</br></br>

Čilaš, Čilag</br></br>

Dečko, Despot, Dilber, Dorat, Doro, Dragan</br></br>

Đogo, Đogat</br></br>

Galin, Gavran, General, Golub</br></br>

Jadran, Jaran</br></br>

Kasač, Kazanova, King, Kulaš</br></br>

Lisac, Lisko, Lola, Lord</br></br>

Mađar, Malin, Moro, Mrka, Mrkalj, Mrkov, Munja, Musa</br></br>

Otoman</br></br>

Paša, Plavac, Puta, Putko</br></br>

Rićko, Riđi, Rubin</br></br>

Senator, Sivac, Sivi, Skopljan, Sokol, Sultan, Sura, Suri</br></br>

Šandor, Šarac, Šargo, Švarc</br></br>

Tatar</br></br>

Vitez, Vranac</br></br>

Zeka, Zekan, Zelenko, Zeus, Zlatko, Zoran</br></br>

Ždral, Žerav</br></br>`
        },
        {
            id: 5,
            title: `Imena kobila se daju na osnovu ličnih imena, na osnovu izgleda, na osnovu podneblja, od milja, internacionalna imena, savremena imena po imenima poznatih javnih ličnosti i drugi načini.</br></br>
            Predstavljamo nekoliko desetina imena za kobile koja su najčešća u našem jeziku i podneblju:`,
            description_path : 'Imena za kobile',
            description : 'Imena za kobile',
            block: 'Imena kobila',
            img : FindIcon.find('Kobila').img2,
            color : FindIcon.find('Kobila').color,
            size : FindIcon.find('Kobila').size,
            names : `
            Albina, Anka, Arna</br></br>

Beba, Belka, Biba, Brenda</br></br>

Carica, Cesarica, Crna, Cura, Cvitka, Cvetka</br></br>

Čilaša</br></br>

Dinka, Dora</br></br>

Gala</br></br>

Jadranka, Jula</br></br>

Kula</br></br>

Linda, Liska, Lola</br></br>

Mađarica, Malča, Mica, Mrka, Munja, Musa</br></br>

Nada</br></br>

Olga</br></br>

Plava, Putka</br></br>

Ranka, Riđa, Riđka, Rosa, Roza, Ruža</br></br>

Selma, Siva, Smilja, Sokolica, Strela</br></br>

Šarga</br></br>

Tara</br></br>

Vatra, Vera, Vida, Vidra, Vrana, Vranka</br></br>

Zeka, Zelenka, Zlata, Zorka</br></br>

Žerava</br></br>`
        },
        {
            id: 6,
            description_path : 'Imena za koze',
            description : 'Imena za koze',
            title: `Imena koza nekada su se davala na osnovu izgleda koze ili od milja, a danas dobijaju i neka savremena imena na osnovu poznatih ličnosti.</br></br>
            Predstavljamo nekoliko imena za koze koja su najčešća u našem jeziku i podneblju:`,
            block: 'Imena koza',
            img : FindIcon.find('Koze').img2,
            color : FindIcon.find('Koze').color,
            size : FindIcon.find('Koze').size,
            names : `Belka, Belica, Biba, Bika, Blizna, Breza, Buba</br>

            Ciga, Cigica, Cina, Cvitka, Cvetka, Crna, Crvena</br>
            
            Čađa, Čađuka</br>
            
            Dika, Dunja</br>
            
            Gala, Gara</br>
            
            Jaga, Jagoda, Jadranka, Jasna, Jela</br>
            
            Kulja</br>
            
            Labuda, Liska, Lija</br>
            
            Maca, Malenka, Mara, Mica, Milka, Mrka, Mrkuša, Mrva</br>
            
            Neva, Nevenka</br>
            
            Obrva, Obrvica</br>
            
            Parica, Pirga, Plemenka, Plemka, Putka</br>
            
            Remka, Ribica, Riđa, Rogulja, Ruža</br>
            
            Sirota, Sokolica, Srna, Srnela</br>
            
            Šara, Šarga, Šarka, Šećerka</br>
            
            Zelena, Zeka, Zekica, Zrna</br>
            
            Žuna, Žuta</br>`
        },
        {
            id: 7,
            title: `Predstavljamo nekoliko  imena za ovnove koja su najčešća u našem jeziku i podneblju:</br></br>`,
            description_path : 'Imena za ovnove',
            description : 'Imena za ovnove',
            block: 'Imena ovnova',
            img : FindIcon.find('Ovnovi za priplod').img2,
            color : FindIcon.find('Ovnovi za priplod').color,
            size : FindIcon.find('Ovnovi za priplod').size,
            names : `Beli, Branko</br>

            Crni</br>
            
            Dobri, Dobrivoje</br>
            
            Garavi</br>
            
            Kitonja</br>
            
            Laki</br>
            
            Ljuba, Ljuban</br>
            
            Maks, Mića, Mile, Mili, Miško</br>
            
            Peca, Peja</br>
            
            Reponja, Rista, Rogonja, Roki</br>
            
            Saša</br>
            
            Šaran, Šaro</br>
            
            Žuća</br>`
        },
        {
            id: 8,
            title: `Imena jagnjadi se daju na osnovu toga da li je jagnje muško ili žensko, tj. da li postaje ovca ili ovan. Često se dešava da uz ime jagnjeta ide ca (Belkica, Rogonjica) ili ić (Kumić).</br></br>`,
            description_path : 'Imena za jagnjad',
            description : 'Imena za jagnjad',
            block: 'Imena jagnjadi',
            img : FindIcon.find('Jagnjad').img2,
            color : FindIcon.find('Jagnjad').color,
            size : FindIcon.find('Jagnjad').size,
            names : ``
        },
        {
            id: 9,
            title: `Imena ždrebadi se daju na osnovu toga da li je ždrebe muško ili žensko, tj. da li postaje konj ili kobila. Često se dešava da uz ime ždrebeta ide ca (Bebica) ili ić (Arapić).</br></br>`,
            description_path : 'Imena za zdrebad',
            description : 'Imena za ždrebad',
            block: 'Imena ždrebadi',
            img : FindIcon.find('Ždrebe').img2,
            color : FindIcon.find('Ždrebe').color,
            size : FindIcon.find('Ždrebe').size,
            names : ``
        },
        {
            id: 10,
            title: `Predstavljamo nekoliko  imena za jarce koja su najčešća u našem jeziku i podneblju:</br></br>`,
            description_path : 'Imena za jarca',
            description : 'Imena za jarca',
            block: 'Imena jarca',
            img : FindIcon.find('Jarad').img2,
            color : FindIcon.find('Jarad').color,
            size : FindIcon.find('Jarad').size,
            names : `
            Beli, Branko</br>

Crni</br>

Dobri, Dobro</br>

Garavi, Garo</br>

Laki</br>

Ljuba, Ljuban</br>

Maks, Mića, Mile, Miki, Mili, Miško</br>

Peca, Peja</br>

Riđi, Rista, Rogonja, Roki</br>

Saša</br>

Šaran, Šaro</br>

Zeka</br>

Žuća</br>
            `
        },
        {
            id: 11,
            title: `Imena jaradi se daju na osnovu toga da li je jare muško ili žensko, tj. da li postaje jarac ili koza. Često se dešava da uz ime jareta ide ca (Belkica, Rogonjica) ili ić (Kumić).</br></br>`,
            description_path : 'Imena za jarad',
            description : 'Imena za jarad',
            block : 'Imena jaradi',
            img : FindIcon.find('Jarad').img2,
            color : FindIcon.find('Jarad').color,
            size : FindIcon.find('Jarad').size,
            names : ``
        },
        {
            id: 12,
            title: `Predstavljamo nekoliko imena za neraste koja su najčešća u našem jeziku i podneblju:</br></br>`,
            description_path : 'Imena za neraste',
            description : 'Imena za neraste',
            block : 'Imena nerasta',
            img : FindIcon.find('Prasad').img2,
            color : FindIcon.find('Prasad').color,
            size : FindIcon.find('Prasad').size,
            names : `
            Beli, Branko</br>

Crni</br>

Dobri, Dobro</br>

Garavi, Garo</br>

Laki</br>

Ljuba, Ljuban</br>

Maks, Mića, Mile, Miki, Mili, Miško</br>

Peca, Peja</br>

Riđi, Rista</br>

Saša</br>

Šaran, Šaro</br>
            `
        },
        {
            id: 13,
            title: `Predstavljamo nekoliko imena za ćurane koja su najčešća u našem jeziku i podneblju:</br></br>`,
            description_path : 'Imena za curane',
            description : 'Imena za ćurane',
            block : 'Imena ćurana',
            img : FindIcon.find('Ćurka').img2,
            color : FindIcon.find('Ćurka').color,
            size : FindIcon.find('Ćurka').size,
            names : `
            Beli</br>

Crni</br>

Ćira</br>

Darko</br>

Garavi</br>

Kuki</br>

Laki, Luki</br>

Ljuba</br>

Maks, Mića, Mile, Miki, Mili, Miško</br>

Peca, Peja</br>

Riđi</br>

Sale</br>

Šaran, Šaro</br>


            `
        },
        {
            id: 14,
            title: `Predstavljamo nekoliko imena za petlove koja su najčešća u našem jeziku i podneblju:</br></br>`,
            description_path : 'Imena za petlove',
            description : 'Imena za petlove',
            block : 'Imena petlova',
            img : FindIcon.find('Petao').img2,
            color : FindIcon.find('Petao').color,
            size : FindIcon.find('Petao').size,
            names : `
            Beli</br>

Crni</br>

Darko</br>

Garavi</br>

Kuki</br>

Laki, Luki</br>

Ljuba</br>

Maks, Mića, Mile, Miki, Mili, Miško</br>

Peca, Peja</br>

Riđi</br>

Sale</br>

Šaran, Šaro</br>

Žuća</br>
            `
        }
        
    ]
}
